import React from 'react';
import { motion } from 'framer-motion';
import articlesMain from '../../../assets/images/resources_screen/articles_main.jpg';
import therapeuticServices from '../../../assets/images/resources_screen/therapeutic_services.jpg';
import articlePdf from '../../../assets/images/resources_screen/article_pdf.jpg';
import articleAOTAPdf from '../../../assets/images/resources_screen/article_aota_pdf.jpg';
import { TfiAngleRight } from 'react-icons/tfi';
import CustomDialog from '../../../components/CustomDialog';
import { IoClose } from 'react-icons/io5';
import { useMediaQuery } from 'react-responsive';
import { Link } from 'react-router-dom';
import { openPdf } from '../../../utils/hooks/utils';
import FastADocument from '../../../assets/documents/fast-a-video-guided-workbook.pdf';

const articlesData = [
  {
    title: 'Anxiety is your friend... usually.',
    description:
      'Anxiety is the uncomfortable feeling we all get when we think something bad might happen. It is a normal, natural feeling that everyone has. Anxiety is often helpful, but sometimes it gets too strong and starts to interfere in our lives. What changes do you notice in your body when you are anxious? Explore this question and more in the pdf.',
    imgUrl: 'article_one.jpg',
    videoUrl: 'https://www.youtube.com/embed/eLBz25JFtqU',
  },
  {
    title: 'Anxiety about real problems',
    description:
      'Is there a SKILL I can learn (like what to say or do) that could help me with this real problem? Would MAKING A PLAN help me with this real problem? If so, brainstorm ideas about what could help, then choose a plan to try.',
    imgUrl: 'article_two.jpg',
    videoUrl: 'https://www.youtube.com/embed/tduVLNUu6GE',
  },
  {
    title: 'Fixing anxiety false alarms',
    description:
      "Brave Practice is about facing our unrealistic fears to learn: what we fear isn't so likely, what we fear isn't so bad, or what we fear is something we can handle. Pick brave practices that can help you reach your goals and test out your specific fears. ",
    imgUrl: 'article_three.jpg',
    videoUrl: 'https://www.youtube.com/embed/LzPsa1YoXpQ',
  },
  {
    title: 'Planning brave practices',
    description: `<span class='font-semibold'>What is your goal?</span> Try to think of 10 brave practices that could help you face your fear and reach your goal. Include practices that would be easy, medium, and hard for you to do.`,
    imgUrl: 'article_four.jpg',
    videoUrl: 'https://www.youtube.com/embed/LFQpEBACDt0',
  },
];

const Articles = () => {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [videoLink, setVideoLink] = React.useState('');
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  const handleVideoOpen = (link) => {
    setVideoLink(link);
    setModalOpen(true);
  };

  return (
    <main id="articles" className="bg-[#F0EFEF]">
      <div className="w-full flex flex-col gap-4 sm:gap-6 md:gap-10 max-w-[1280px] mx-auto px-4 md:px-10 py-10 md:py-20 relative z-10">
        <h2 className="text-[38px] sm:text-[50px] 3xl:text-[70px] text-[#8258A4] font-bold leading-tight sm:px-6">
          Articles
        </h2>
        <div
          id="therapeutic_listenings"
          style={{
            background:
              'linear-gradient(-45deg, #493F99 0%, #755EA8 67%, #D36CAA 100%)',
          }}
          className="w-full rounded-2xl md:rounded-[50px] p-6 md:px-14 md:pt-10 md:pb-16 mt-4 md:mt-10"
        >
          <h2 className="text-[48px] sm:text-[60px] 3xl:text-[75px] text-white font-bold leading-tight mb-4">
            Therapeutic Listening
          </h2>
          <div className="flex flex-col w-full gap-4 md:flex-row md:justify-between md:gap-10">
            <div className="flex flex-col flex-1 gap-4">
              <p className="text-lg text-white 2xl:text-xl">
                Guidepost Pediatric offers Therapeutic Listening, a
                comprehensive, multi-faceted sound-based treatment. It is a
                powerful sound-based auditory intervention that is intended to
                be incorporated into a larger whole-body, sensory integrative
                treatment perspective. Therapeutic Listening is ideally part of
                a comprehensive clinic, school, and home based treatment
                progression that systematically helps the child to not only
                cope, but thrive across environments. In fact, practitioners
                often report that Therapeutic Listening increases the rate of
                improvements seen in their clients.
              </p>
              <p className="text-lg text-white 2xl:text-xl">
                Ask about our Therapeutic Listening treatment today.
              </p>
              <Link
                to="/contact"
                className="inline-block text-sm md:text-lg 2xl:text-xl text-white font-semibold border-[3px] md:w-fit border-white hover:bg-primary hover:border-[#764D99] rounded-md py-1 px-4 transition-all duration-300 transform hover:scale-105"
              >
                Contact Us
              </Link>
            </div>
            <div className="flex-1">
              <h3 className="text-[24px] sm:text-[34px] text-white font-bold leading-tight mb-4">
                What is Therapeutic Listening?
              </h3>
              <a
                href="https://www.youtube.com/watch?v=sR9y71GV5b4"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={therapeuticServices}
                  alt="listening"
                  className="cursor-pointer"
                />
              </a>
            </div>
          </div>
        </div>
        <div
          className="flex flex-col-reverse md:flex-row justify-between items-center gap-6 md:gap-16 py-6 px-6 md:px-10 rounded-[30px]"
          style={{
            background:
              'linear-gradient(-45deg, #493F99 0%, #755EA8 67%, #D36CAA 100%)',
          }}
        >
          <div id="anxiety" className="flex flex-col flex-1 gap-2 sm:gap-4">
            <h1 className="text-[38px] sm:text-[50px] 3xl:text-[70px] text-white font-bold leading-tight">
              Anxiety
            </h1>
            <h2 className="text-[28px] sm:text-[38px] text-white font-bold leading-tight">
              Introduction to Fast-A
            </h2>
            <p className="text-lg text-white 2xl:text-2xl">
              AST-A is a tool to help you understand and overcome problems with
              anxiety. Download and work through the PDF workbook and watch the
              below videos in order to help you or your child put anxiety in
              it’s proper place.&nbsp;
              <button
                onClick={() => openPdf(FastADocument)}
                className="font-bold text-[#FED403] cursor-pointer hover:underline"
              >
                DOWNLOAD PDF
              </button>
              &nbsp;and play the intro video.
            </p>
          </div>
          <div className="flex-1">
            <img
              src={articlesMain}
              onClick={() =>
                handleVideoOpen(
                  'https://www.youtube.com/embed/Ru_1n87BRT0?si=i2kUsVMcS0YZNdmc'
                )
              }
              alt="babyOne"
              className="cursor-pointer w-full sm:max-w-[350px] md:max-w-[400px] xl:max-w-[450px] 2xl:max-w-[500px] [clip-path:inset(3px)]"
            />
          </div>
        </div>

        <div className="flex flex-col gap-10 pt-6 2xl:gap-24 sm:px-6">
          {articlesData.map((item, index) => {
            return (
              <article
                key={index}
                className={`flex flex-col ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                } gap-4 items-end sm:gap-10`}
              >
                <div className="flex-1">
                  <motion.div
                    initial={{ opacity: 0, x: index % 2 === 0 ? -100 : 100 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, ease: 'easeInOut' }}
                    viewport={{ once: true, amount: 0.5 }}
                  >
                    <img
                      src={require(
                        '../../../assets/images/resources_screen/' + item.imgUrl
                      )}
                      onClick={() => handleVideoOpen(item.videoUrl)}
                      alt="axity"
                      className="cursor-pointer [clip-path:inset(3px)]"
                    />
                  </motion.div>
                </div>
                <motion.div
                  initial={{ opacity: 0, x: index % 2 === 0 ? 100 : -100 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, ease: 'easeInOut' }}
                  viewport={{ once: true, amount: 0.5 }}
                  className={`flex-1 flex flex-col gap-4 text-left ${
                    index % 2 === 0 ? 'md:text-left' : 'md:text-right'
                  }`}
                >
                  <h2 className="text-[28px] sm:text-[34px] text-primary font-bold leading-tight">
                    {index + 1}.&nbsp;{item.title}
                  </h2>
                  <p
                    className="text-lg text-secondary 2xl:text-2xl"
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  />
                </motion.div>
              </article>
            );
          })}
        </div>

        <div className="flex flex-col gap-4">
          <h2 className="text-[38px] sm:text-[50px] 3xl:text-[70px] text-[#8258A4] font-bold leading-tight sm:px-6 pt-4 md:pt-8">
            Other Articles
          </h2>

          <div className="flex flex-col-reverse items-center gap-4 mb-8 md:flex-row md:justify-between md:gap-12">
            <div className="flex-[55%] flex flex-col items-center md:items-end gap-2">
              <h4 className="text-[20px] sm:text-[28px] text-[#0A9648] font-bold leading-tight md:mr-10 text-center md:text-right">
                The ABC’s of Pediatric Physical Therapy
              </h4>
              <div className="flex items-center gap-1 group">
                <a
                  // download={"pediatric_fact_sheet"}
                  href={require('../../../assets/documents/pediatric_fact_sheet.pdf')}
                  target="_blank"
                  rel="noreferrer"
                  className="text-[20px] sm:text-[28px] text-[#777777] cursor-pointer hover:underline font-bold leading-tight"
                >
                  Download PDF
                </a>
                <TfiAngleRight className="text-[#0A9648] text-2xl md:text-4xl group-hover:translate-x-1 transition-all duration-300" />
              </div>
            </div>
            <div className="flex-[45%]">
              <motion.div
                initial={{ opacity: 0, x: isMobile ? 50 : 200 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, ease: 'easeInOut' }}
                viewport={{ once: true, amount: 0.4 }}
              >
                <img
                  src={articlePdf}
                  alt="listening"
                  className="max-h-[450px] object-contain"
                />
              </motion.div>
            </div>
          </div>

          <div className="flex flex-col-reverse items-center gap-4 md:flex-row md:justify-between md:gap-12">
            <div className="flex-[55%] flex flex-col items-center md:items-end gap-2">
              <h4 className="text-[20px] sm:text-[28px] text-[#0A9648] font-bold leading-tight md:mr-10 text-center md:text-right">
                What is the Role of Occupational Therapy
                <br /> in Early Intervention?
              </h4>
              <div className="flex items-center gap-1 group">
                <a
                  // download={"pediatric_fact_sheet"}
                  href={require('../../../assets/documents/AOTA_Early_Intervention_FAQ_Final3.pdf')}
                  target="_blank"
                  rel="noreferrer"
                  className="text-[20px] sm:text-[28px] text-[#777777] cursor-pointer hover:underline font-bold leading-tight"
                >
                  Download PDF
                </a>
                <TfiAngleRight className="text-[#0A9648] text-2xl md:text-4xl group-hover:translate-x-1 transition-all duration-300" />
              </div>
            </div>
            <div className="flex-[45%]">
              <motion.div
                initial={{ opacity: 0, x: isMobile ? 50 : 200 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, ease: 'easeInOut' }}
                viewport={{ once: true, amount: 0.4 }}
              >
                <img
                  src={articleAOTAPdf}
                  alt="listening"
                  className="max-h-[450px] object-contain"
                />
              </motion.div>
            </div>
          </div>
        </div>
      </div>

      <CustomDialog open={modalOpen} setOpen={setModalOpen}>
        <div className="relative flex items-center justify-center w-full h-full p-4">
          <IoClose
            onClick={() => setModalOpen(false)}
            className="absolute right-0 z-50 text-4xl text-white cursor-pointer -top-4 md:-right-4"
          />
          <iframe
            src={videoLink}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="w-[95vw] h-[400px] md:w-[84vw] md:max-h-[90vh] md:h-[700px] xl:w-[70vw] 3xl:w-[75vw] 3xl:h-[1600px] rounded-md shadow-lg"
          />
        </div>
      </CustomDialog>
    </main>
  );
};

export default Articles;
